import React from "react";
import CookieTable from "../../components/ui/CookieTable";
import {
  // advertisementCookiesTableData,
  cookieTableData,
  // functionalCookiesTableData,
  // marketingAnalyticsCookiesTableData,
  // strictlyNecessaryCookieData,
} from "../../data/Cookies";
// import BrowserInstructions from "../../components/ui/BrowseInstructions";
// import {
//   generalInstructions,
//   macInstructions,
// } from "../../data/browserInstructions";

const CookiePolicy = () => {
  return (
    <section className="w-full bg-primary text-white relative">
      <div className="max-w-6xl mx-auto px-4 py-16 pt-32 md:pt-40 flex flex-col md:flex-row items-center">
        <h1 className="text-brandAccent text-4xl md:text-5xl font-extrabold mb-4">
          Cookie Policy
        </h1>
      </div>
      <div className="px-4 md:px-12 py-32 rounded-tl-3xl bg-white text-primary">
        {/* <p className="mb-5 text-base md:text-lg">
          <span className="font-bold">Effective Date:</span> 07 July 2024{" "}
          <span className="font-bold pl-3">Last Updated:</span> 07 July 2024
        </p> */}

        <p className="mb-5 text-base md:text-lg">
          This Cookies Policy explains how Zorqk.com (“Zorqk”, “we”, “us”, or
          “our”) uses cookies and similar technologies to recognize you when you
          visit our website. It explains what these technologies are, why we use
          them, and your rights to control their use.
        </p>

        <h1 className="font-bold text-lg md:text-2xl my-8">
          1. What Are Cookies?
        </h1>
        <p className="mb-5 text-base md:text-lg">
          Cookies are small text files that are stored on your device when you
          visit a website. They help websites remember your preferences, improve
          functionality, and analyze usage to enhance user experience.
        </p>

        <h1 className="font-bold text-lg md:text-2xl my-8">
          2. Types of Cookies We Use{" "}
        </h1>
        <p className="mb-5 text-base md:text-lg">
          We use the following types of cookies on Zorqk.com:
        </p>
        <CookieTable data={cookieTableData} />

        <h1 className="font-bold text-lg md:text-2xl my-8">
          3. Third-Party Cookies{" "}
        </h1>
        <p className="mb-5 text-base md:text-lg">
          Some cookies may be set by third-party services we use, such as:{" "}
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
          <li>Analytics providers (e.g., Google Analytics)</li>
          <li>Advertising networks</li>
          <li>Embedded content providers (e.g., YouTube, social media)</li>
        </ul>
        <p className="mb-5 text-base md:text-lg">
          These third parties may use cookies to collect information about your
          online activities across websites.
        </p>

        <h1 className="font-bold text-lg md:text-2xl my-8">
          4. How You Can Control Cookies{" "}
        </h1>
        <p className="mb-5 text-base md:text-lg">
          You have the right to accept or reject cookies:{" "}
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
          <li>
            <span className="font-bold">Cookie Banner: </span> When you first
            visit our site, you’ll be asked to accept or manage your cookie
            preferences.
          </li>
          <li>
            <span className="font-bold">Browser Settings:</span> You can adjust
            your browser settings to block or delete cookies.
          </li>
          <li>
            <span className="font-bold">Opt-Out Tools:</span> You may opt out of
            certain third-party cookies via their own tools or industry-wide
            platforms.
          </li>
        </ul>
        <p className="mb-5 text-base md:text-lg">
          Please note that disabling certain cookies may affect the
          functionality of our website.{" "}
        </p>

        <h1 className="font-bold text-lg md:text-2xl my-8">
          5. Data Collected via Cookies{" "}
        </h1>
        <p className="mb-5 text-base md:text-lg">
          Cookies may collect the following types of data:
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
          <li>IP address and device type</li>
          <li>Browser type and version</li>
          <li>Pages visited and time spent</li>
          <li>Referral source and clickstream data</li>
        </ul>
        <p className="mb-5 text-base md:text-lg">
          This data is used in accordance with our Privacy Policy.{" "}
        </p>

        <h1 className="font-bold text-lg md:text-2xl my-8">
          6. Changes to This Policy
        </h1>
        <p className="mb-5 text-base md:text-lg">
          We may update this Cookies Policy from time to time to reflect changes
          in technology, law, or our services. Any updates will be posted on
          this page with a revised “Last Updated” date.{" "}
        </p>

        <h1 className="font-bold text-lg md:text-2xl my-8">7. Contact Us</h1>
        <p className="mb-5 text-base md:text-lg">
          If you have any questions about our use of cookies,please contact us
          at: {" "}
          <a
            href="mailto:support@zorqk.com"
            className="text-blue-400 font-bold"
          >
            support@zorqk.com
          </a>
        </p>
      </div>
    </section>

    // <section className="w-full bg-primary text-white relative">
    //   <div className="max-w-6xl mx-auto px-4 py-16 pt-32 md:pt-40 flex flex-col md:flex-row items-center">
    //     <h1 className="text-brandAccent text-4xl md:text-5xl font-extrabold mb-4">
    //       Cookie Policy
    //     </h1>
    //   </div>
    //   <div className="px-4 md:px-12 py-32 rounded-tl-3xl bg-white text-primary">
    //     <p className="mb-5 text-base md:text-lg">
    //       We use cookies to make our websites more user-friendly or enable them
    //       to work effectively on your machine. A cookie is a small file, which
    //       will be placed on your device. Find out about the main types of
    //       cookies we use and what we use them for below. If you want to know how
    //       to delete cookies, go to our deleting cookies section.
    //     </p>
    //     <p className="mb-5 text-base md:text-lg">
    //       This Cookie Policy may change from time to time due to developments in
    //       technology or business, new services or when any legal guidance is
    //       published.
    //     </p>
    //     <p className="mb-5 text-base md:text-lg font-extrabold">
    //       Last updated: 10 Sept 2024
    //     </p>
    //     <p className="mb-5 text-base md:text-lg">
    //       The data we collect using cookies helps us understand our customers
    //       better to provide a more focused user experience. Using the knowledge
    //       of your previous visits to our website, ZORQK can enhance subsequent
    //       visits by tailoring our content to match your requirements.
    //     </p>
    //     <p className="mb-5 text-base md:text-lg">
    //       We use cookies principally because we want to make our websites and
    //       mobile applications user-friendly. We are interested in anonymous user
    //       behaviour. Generally, our cookies don't store sensitive or personally
    //       identifiable information such as your name and address or credit card
    //       details.
    //     </p>
    //     <p className="mb-5 text-base md:text-lg">
    //       In the unlikely event that our websites use cookies to store personal
    //       information about you, ZORQK encrypts the personal data or has
    //       validated the 3rd party cookie encrypts the personal data to prevent
    //       unauthorised use by anyone else.
    //     </p>
    //     <p className="mb-5 text-base md:text-lg">
    //       We will always give you the chance to accept or decline non-essential
    //       cookies beyond the choice you make when you first see our cookie
    //       banner.
    //     </p>
    //     <button
    //       type="submit"
    //       className="
    //                 w-fit inline-flex justify-center
    //                 py-3 px-16
    //                 border border-accent
    //                 shadow-sm
    //                 text-base font-medium
    //                 rounded-full
    //                 text-white bg-primary
    //                 transform transition duration-200 ease-in-out
    //                 hover:bg-accent my-5
    //               "
    //     >
    //       Edit Cookie Preferences
    //     </button>
    //     <p className="my-10 text-base md:text-lg font-extrabold">
    //       This button allows you to change your cookie preferences on the
    //       website only. If you are using the ZORQK app, you can change your
    //       preferences using the settings under My profile.
    //     </p>
    //     <p className="my-5 text-base md:text-lg">
    //       <a
    //         href="https://www.allaboutcookies.org"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         className="underline pr-1"
    //       >
    //         www.allaboutcookies.org
    //       </a>
    //       provides further information about cookies and also how to use
    //       settings to manage them on different types of devices.
    //     </p>
    //     <p className="my-10 text-base md:text-lg font-extrabold">
    //       If you’re using the ZORQK app
    //     </p>
    //     <p className="my-5 text-base md:text-lg">
    //       In addition to the cookies listed above, we use the following
    //       technologies on our app:
    //     </p>
    //     <ul className="text-base md:text-lg pl-6 list-disc space-y-2 mb-10">
    //       <li>
    //         Datadog – essential monitoring of the app performance and usage
    //       </li>
    //       <li> Adobe - general analytics</li>
    //       <li> Segment - marketing analytics</li>
    //     </ul>
    //     <p className="my-5 text-base md:text-lg">
    //       We’ll always ask permission before setting non-essential cookies, but
    //       you are also able to update your preferences at any time by visiting
    //       the Settings in the app itself. Please note the ‘Edit Cookie
    //       Preferences’ button below is just for cookies set by the main website
    //       on your browser, so doesn’t update the app.
    //     </p>
    //     <p className="my-10 text-base md:text-lg">
    //       The cookies listed below are the cookies used on our site, if they are
    //       a third party clicking on the company’s name will take you to the
    //       third parties privacy policy where more information about the
    //       information they gather can be found.
    //     </p>
    //     <p className="my-10 text-base md:text-lg font-extrabold">
    //       Strictly Necessary = These are needed to make the site function
    //     </p>
    //     <CookieTable data={strictlyNecessaryCookieData} />
    //     <h3 className="font-bold text-xl mt-10">Functional –</h3>
    //     <p className="my-5 text-base md:text-lg">
    //       To monitor the performance of our site and to enhance your browsing
    //       experience. For example, these tools enable you to communicate with us
    //       via live chat.
    //     </p>
    //     <CookieTable data={functionalCookiesTableData} />
    //     <h3 className="font-bold text-xl mt-10">Advertisement –</h3>
    //     <p className="my-5 text-base md:text-lg">
    //       To personalize and measure the effectiveness of advertising on our
    //       site and other websites. For example, we may serve you a personalized
    //       ad based on the pages you visit on our site.
    //     </p>
    //     <p className="my-5 text-base md:text-lg">
    //       Accepting advertising cookies means your data (including anonymous IDs
    //       or other encrypted identifiers) may be shared with the third parties
    //       specified below.
    //     </p>
    //     <CookieTable data={advertisementCookiesTableData} />
    //     <h3 className="font-bold text-xl mt-10">Marketing and Analytics –</h3>
    //     <p className="my-5 text-base md:text-lg">
    //       Marketing cookies are used to track visitors across websites. The
    //       intention is to display ads that are relevant and engaging for the
    //       individual user and thereby more valuable for publishers and
    //       third-party advertisers.
    //     </p>
    //     <p className="my-5 text-base md:text-lg">
    //       Statistic cookies help website owners to understand how visitors
    //       interact with websites by collecting and reporting information
    //       anonymously.
    //     </p>
    //     <p className="my-5 text-base md:text-lg">
    //       Accepting Marketing and Analytics cookies means your data (including
    //       anonymous IDs or other encrypted identifiers) may be shared with the
    //       third parties specified below.
    //     </p>
    //     <CookieTable data={marketingAnalyticsCookiesTableData} />
    //     <h1 className="font-bold text-2xl md:text-4xl border-b-2 pb-5 my-10">
    //       Deleting Cookies
    //     </h1>
    //     <p className="mb-5 text-base md:text-lg">
    //       If you are using a PC please see the below, these steps may change if
    //       the supplier of the browser updates their browser and changes these
    //       steps
    //     </p>
    //     <BrowserInstructions instructions={generalInstructions} />
    //     <p className="py-5 text-base md:text-lg">
    //       If you are using a Mac please see the below, these steps may change if
    //       the supplier of the browser updates their browser and changes these
    //       steps
    //     </p>
    //     <BrowserInstructions instructions={macInstructions} />
    //   </div>
    // </section>
  );
};

export default CookiePolicy;
